import {Injectable} from '@angular/core';
import {TorchAPIConfiguration} from "../../../config/api.configuration";
import {HttpClient} from "@angular/common/http";
import {Burly} from "kb-burly";
import {Observable} from "rxjs";
import { RepairSupplierDistinctMpn } from '../models/repair-supplier/repair-supplier-distinct-mpn.model';
import { RepairSupplier } from '../models/repair-supplier/repair-supplier.model';

@Injectable({
  providedIn: 'root'
})
export class TorchRepairSupplierService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  public getRepairSupplierByCpn(partNumber: string,
                                filter?: string | string[]): Observable<RepairSupplier[]> {

    let finalURL;
    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/repair-supplier')
    .addSegment('/by-cpn/' + partNumber);

    finalURL = endpointURL.get;

    if (filter) {
      if (filter instanceof Array) {
        if (filter.length > 0) {
          filter.forEach((filterValue, index) => {
            if (index === 0) {
              finalURL = `${finalURL}?filters=${encodeURIComponent(filterValue)}`;
            } else {
              finalURL = `${finalURL}&filters=${encodeURIComponent(filterValue)}`;
            }
          });
        }
      } else {
        finalURL = `${finalURL}?filters=${encodeURIComponent(filter)}`;
      }
    }

    return this.httpClient.get<RepairSupplier[]>(finalURL);
  }

  public getRepairSupplierByCpnAndMpn(partNumber: string,
                                      mpn: string,
                                      filter?: string | string[]): Observable<RepairSupplier[]> {

    let finalURL;
    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/repair-supplier')
    .addSegment('/by-cpn-mpn/' + partNumber)
    .addSegment('/' + mpn);

    finalURL = endpointURL.get;

    if (filter) {
      if (filter instanceof Array) {
        if (filter.length > 0) {
          filter.forEach((filterValue, index) => {
            if (index === 0) {
              finalURL = `${finalURL}?filters=${encodeURIComponent(filterValue)}`;
            } else {
              finalURL = `${finalURL}&filters=${encodeURIComponent(filterValue)}`;
            }
          });
        }
      } else {
        finalURL = `${finalURL}?filters=${encodeURIComponent(filter)}`;
      }
    }

    return this.httpClient.get<RepairSupplier[]>(finalURL);
  }

  public getRepairSupplierMpnByCpn(companyPartNumber) {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/repair-supplier')
      .addSegment('/distinct/' + companyPartNumber)
      .get;

    return this.httpClient.get<RepairSupplierDistinctMpn[]>(endpoint);
  }
}
